import { cicloApi } from "../view/ciclo.service";

export const editCiclo = cicloApi.injectEndpoints({
  endpoints: (builder) => ({
    editCiclo: builder.mutation({
      query: (data) => {
        return {
          url: `/v1/api/ciclo/custom_update/`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: [{ type: "Ciclo", id: "LIST" }],
    }),
  }),
});

export const { useEditCicloMutation } = editCiclo;
